import React from 'react'
import PropTypes from 'prop-types'
import UserInfoAccount from './UserInfoAccount'
import './UserInfo.css'

const UserInfo = ({ label, value, account, buttonText, onClick}) => {
  let subElements = null
  if (account) {
    subElements = <UserInfoAccount account={account} onClick={onClick}/>
  } else {
    subElements =
      <React.Fragment>
        <label className='up-ui-te'>
          {value}
        </label>
        <button className='up-ui-bu' onClick={onClick}>
          {buttonText ? buttonText : 'Změnit'}
        </button>
      </React.Fragment>
  }
  return (
    <div  className='up-ui-con' >
      <label className='up-ui-la'>{label}</label>
      {subElements}
    </div>
  )
}

UserInfo.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  account: PropTypes.object,
  buttonText: PropTypes.string,
  onClick: PropTypes.func
}

export default UserInfo



// WEBPACK FOOTER //
// ./src/components/User/UserInfo.js